export default {
  props: {
    group: {
      type: Object,
      default: undefined,
    },
    customization: {
      type: Object,
      default: undefined,
    },
  },
};
